import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

import { FlexRow } from 'ui-components/components/flex/row';
import { FlexColumn } from 'ui-components/components/flex/column';
import { Gap } from 'ui-components/components/flex/gap';

import style from './operations-cards.module.less';

/** Skeleton loading state for an operations card */
export const OperationsCardSkeleton = () => {
  return (
    <div className={style['operations-card-skeleton']}>
      <FlexRow className={style['operations-card-content']}>
        <FlexColumn className={style['operations-card-top']} gap={Gap.Space4}>
          <Skeleton height={16} width={100} />
          <Skeleton height={32} width={60} />
          <Skeleton height={16} width={120} />
        </FlexColumn>
        <Skeleton circle height={48} width={48} />
      </FlexRow>
    </div>
  );
};
